import React, { useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import useStyles from "./styles";
import { Pagination } from "@material-ui/lab";
import clsx from "clsx";
import { __t } from "@core/translation/translation";
import Empty from "@components/Empty";

const CustomTableWithPagination = props => {
  let {
    type,
    className,
    TableOption,
    data,
    is_fetch,
    handleChange,
    pageNumber,
    count,
    pageSize,
    pagination,
    emptySize,
    handleClick,
    emptyNote,
    noteComponent,
    cursorType
  } = props;

  const classes = useStyles({ type, cursorType });
  const getCellContent = (row, col) => {
    if (col?.render) {
      return col?.render(row, col?.name);
    } else {
      return row[col?.name];
    }
  };
  return (
    <>
      {is_fetch &&
        (data?.length > 0 ? (
          <div className={className}>
            <TableContainer>
              <Table className={classes.table}>
                <colgroup>
                  {TableOption?.map(item => (
                    <>
                      <col style={{ width: item?.width }} />
                    </>
                  ))}
                </colgroup>
                <TableHead className={classes.tableHead}>
                  <TableRow className={classes.tableRow}>
                    {TableOption?.map(item => (
                      <TableCell
                        className={
                          item.lastFixed === true
                            ? clsx(classes.tableCell, classes.lastFixedHead)
                            : clsx(classes.tableCell)
                        }
                        align={item.align ? item.align : "center"}
                      >
                        {item.title}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.map((row, index) => (
                    <TableRow
                      key={row?.id}
                      id={row?.currencyName && row?.currencyName}
                      className={classes.tableRow}
                      onClick={handleClick}
                    >
                      {TableOption?.map(item => (
                        <TableCell
                          className={
                            item?.lastFixed === true
                              ? clsx(classes.tableCell, classes.lastFixed)
                              : clsx(classes.tableCell)
                          }
                          align={item?.align ? item?.align : "center"}
                        >
                          {getCellContent(row, item)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {count && pageSize && count > pageSize && pagination && (
              <div className={classes.pagination}>
                <Pagination
                  count={Math.ceil(count / pageSize)}
                  onChange={handleChange}
                  variant="outlined"
                  page={pageNumber + 1}
                />
              </div>
            )}
          </div>
        ) : (
          <Empty
            note={!!emptyNote ? emptyNote : __t("There is no data to display")}
            size={emptySize}
            noteComponent={noteComponent}
          />
        ))}
    </>
  );
};

export default CustomTableWithPagination;
